import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "@/components/utils";
import withTooltip from "@/hocs/withTooltip";

const badgeVariants = cva(
  "rounded-full border font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 truncate",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        background: "border-transparent bg-background text-foreground",
        "outline-background": "border-background text-background",
        success: "bg-success/20 text-success-foreground border-success/20",
        "outline-success": "border-success text-success",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        warning: "border-orange-300 bg-orange-100 text-orange-600",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        "outline-purple": "border-purple-500 text-purple-500",
        "outline-primary": "border-primary text-primary",
        "outline-orange": "border-orange-500 text-orange-500",
        "outline-warning": "border-warning text-warning",
        "outline-destructive": "border-destructive text-destructive",
      },
      size: {
        default: "px-3 py-1 text-sm",
        sm: "px-2 py-1 text-[11px]",
        lg: "px-4 py-1 text-md",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Badge({ className, variant, size = "default", ...props }) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

const BadgeWithTooltip = withTooltip()(Badge);

export { BadgeWithTooltip as Badge, badgeVariants };
